
/* injects from baggage-loader */

'use strict';

import { words } from './page-nine.const.js';

import { shuffle, cloneDeep } from 'lodash';

export default class PageNineController {
    constructor($state, $log, Dialog) {
        'ngInject'; 
        this.$state = $state;
        this.$log = $log;
        this.step = 0;
        this.passPage = false;
        this.Dialog = Dialog;
        this.class = "disable";
        this.dialogs = [
        {
            words: shuffle([0,1,2]),
            answers: [0,1,2]
        },
        {
            words: shuffle([3,4]),
            answers: [3]
        },
        {
            words: shuffle([5,6]),
            answers: [5]
        },
        {
            words: shuffle([7,8,9,10]),
            answers: [7,8,9,10]
        },

        ];
        this.checked = [];
        this.embedded = require('_images/page-nine/Caixa_parabens.png');
    }

    $onInit(){
        this.words = cloneDeep(words);
    }

    $onDestroy(){
        this.resetStage();
    }

    checkDrop(num){
        this.words[num].text = "";
        this.words[num].class += " blank";
        this.checked.push(num);
        if(this.checked.length === this.dialogs[this.step].answers.length){
            this.passPage = true;
            this.checked = [];
            if(this.step === 3)
                this.class = 'enable end'
            else
                this.class = 'enable';
        }
    }

    nextDialog(){
        if((this.step === 3) && (this.class === 'enable end') ){
            this.Dialog.showEmbedded(this.embedded, 0, this.redirectToStages.bind(this));
        } else if(this.class === 'enable'){
            this.passPage = false;
            if(this.step === 2)
                this.class = 'disable end';
            else
                this.class = 'disable';
            this.step++;
        } else {
            return false;
        }
    }

    resetStage() {   
        return false;
    }

    redirectToStages(){
        this.$state.go("page-ten");
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-nine/page-nine.controller.js